import { MAIN_OFFER_TYPE, OFFER_CATEGORY } from "../../../enums";
import {
  AmountOfferType,
  BogoOfferType,
  ItemOfferType,
  OfferTypeV2,
} from "../../../types";
import { AmountOffer } from "../../AmountOffer/AmountOffer";
import { BogoOffer } from "../../BogoOffer/BogoOffer";
import { ItemOffer } from "../../ItemOffer/ItemOffer";
import Offer from "../../Offer/Offer";

export const createOffer = (offer: OfferTypeV2) => {
  return createOfferByCategory(offer);
};

const createOfferByCategory = (offer: OfferTypeV2) => {
  let newOffer: Offer;
  if (!offer.offerCategory) {
    offer = {
      ...offer,
      offerCategory: detectOfferCategory(offer.offerType as MAIN_OFFER_TYPE),
    };
  }
  switch (offer.offerCategory) {
    case OFFER_CATEGORY.AMOUNT_OFFER:
      newOffer = new AmountOffer(offer as AmountOfferType);
      break;
    case OFFER_CATEGORY.ITEM_OFFER:
      newOffer = new ItemOffer(offer as ItemOfferType);
      break;
    case OFFER_CATEGORY.BOGO_OFFER:
      newOffer = new BogoOffer(offer as BogoOfferType);
      break;
  }

  return newOffer;
};

const detectOfferCategory = (offerType: MAIN_OFFER_TYPE) => {
  let offerCategory: OFFER_CATEGORY;
  switch (offerType) {
    case MAIN_OFFER_TYPE.FIXED_AMOUNT:
    case MAIN_OFFER_TYPE.PERCENTAGE_AMOUNT:
    case MAIN_OFFER_TYPE.MULTIPLIER:
      offerCategory = OFFER_CATEGORY.AMOUNT_OFFER;
      break;
    case MAIN_OFFER_TYPE.DISCOUNT_ITEM:
    case MAIN_OFFER_TYPE.FREE_ITEM:
    case MAIN_OFFER_TYPE.BUNDLE:
      offerCategory = OFFER_CATEGORY.ITEM_OFFER;
      break;
    case MAIN_OFFER_TYPE.BOGO:
      offerCategory = OFFER_CATEGORY.BOGO_OFFER;
      break;
    default:
      offerCategory = OFFER_CATEGORY.AMOUNT_OFFER;
      break;
  }

  return offerCategory;
};

export function expandSubOffers(offers: Offer[]): Offer[] {
  const expandedOffers: Offer[] = [];

  offers?.forEach((offer) => {
    if (offer instanceof BogoOffer) {
      expandedOffers.push(offer.getOffer);
    }

    expandedOffers.push(offer);
  });

  return expandedOffers;
}
